import React from 'react';
const steps = [{
  icon: '🎯',
  step: '01',
  title: 'Descarga las plantillas',
  desc: 'Plantillas de CapCut listas para usar. Gratis. Ya están en tu teléfono.'
}, {
  icon: '✂️',
  step: '02',
  title: 'Edita en 15 minutos',
  desc: 'Videos de 15-60 segundos con los guiones exactos que te doy.'
}, {
  icon: '📱',
  step: '03',
  title: 'Consigue clientes',
  desc: 'Scripts de DM incluidos para contactar negocios locales en Instagram.'
}, {
  icon: '💰',
  step: '04',
  title: 'Cobra en dólares',
  desc: '$150-$300 por paquete de 5 videos. Clientes que pagan bien y rápido.'
}, {
  icon: '🔄',
  step: '05',
  title: 'Escala a $800+/mes',
  desc: 'Repite el sistema. 3-4 clientes fijos y ya tienes tu ingreso estable.'
}];
export function Solution() {
  return <section id="solucion" className="bg-[#fdf6ee] py-16 md:py-24" data-id="element-338">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-339">
        {/* Label */}
        <div className="text-center mb-4" data-id="element-340">
          <span className="font-dm text-xs font-bold tracking-widest text-[#c9a84c] uppercase" data-id="element-341">
            La solución
          </span>
        </div>

        {/* Heading */}
        <div className="text-center mb-6" data-id="element-342">
          <h2 className="font-playfair text-3xl md:text-5xl font-bold text-[#0d4a45] leading-tight" data-id="element-343">
            Presentamos:{' '}
            <span className="text-[#c9a84c]" data-id="element-344">REEL-MOM ESTRATÉGICA</span>
          </h2>
          <p className="font-dm text-[#3a3a3a] text-lg md:text-xl mt-4 max-w-2xl mx-auto leading-relaxed" data-id="element-345">
            El sistema de <strong data-id="element-346">'Invisible Freelancing'</strong> diseñado para
            la mujer que no tiene tiempo, pero tiene hambre de éxito.
          </p>
        </div>

        {/* Product image */}
        <div className="flex justify-center mb-12" data-id="element-347">
          <div className="relative max-w-xs w-full" data-id="element-348">
            <div className="absolute inset-0 bg-[#c9a84c]/20 rounded-2xl blur-xl scale-90 pointer-events-none" data-id="element-349" />
            <img src="https://cdn.magicpatterns.com/uploads/sYCio2eLc3TrS795cZEAQD/REEL-MOM_ESTRATEGICA.png" alt="Reel-Mom Estratégica" className="relative rounded-2xl shadow-xl w-full" data-id="element-350" />
          </div>
        </div>

        {/* Description */}
        <div className="bg-white border border-[#0d4a45]/10 rounded-2xl p-6 md:p-8 mb-12 text-center max-w-3xl mx-auto shadow-sm" data-id="element-351">
          <p className="font-dm text-[#3a3a3a] text-lg leading-relaxed" data-id="element-352">
            He condensado cómo usar plantillas que ya existen para resolver el{' '}
            <strong className="text-[#0d4a45]" data-id="element-353">
              problema #1 de los negocios en USA:
            </strong>{' '}
            La falta de videos cortos (Reels/TikToks) para vender. Tú eres la
            solución que ellos necesitan.
          </p>
        </div>

        {/* 5-step process */}
        <h3 className="font-playfair text-2xl md:text-3xl font-bold text-[#0d4a45] text-center mb-8" data-id="element-354">
          El plan de 5 pasos para tu libertad financiera
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4" data-id="element-355">
          {steps.map(s => <div key={s.step} className="bg-white rounded-2xl p-5 shadow-sm border border-[#0d4a45]/8 text-center flex flex-col items-center" data-id="element-356">
              <div className="text-3xl mb-2" data-id="element-357">{s.icon}</div>
              <div className="font-dm text-xs font-bold text-[#c9a84c] tracking-widest mb-1" data-id="element-358">
                PASO {s.step}
              </div>
              <h4 className="font-playfair font-bold text-[#0d4a45] text-base mb-2" data-id="element-359">
                {s.title}
              </h4>
              <p className="font-dm text-[#5a5a5a] text-sm leading-relaxed" data-id="element-360">
                {s.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}